import React from 'react';
export function SolutionSection() {
  return <section className="py-16 px-4 bg-[#6242EE]" data-id="element-239">
      <div className="max-w-3xl mx-auto text-center" data-id="element-240">
        <div className="inline-block bg-green-100 text-green-800 px-6 py-2 rounded-full font-bold text-lg mb-8" data-id="element-241">
          ✅ LA SOLUCIÓN
        </div>

        <h2 className="text-4xl md:text-5xl font-black mb-8 text-[#000000] bg-[#6242EE]" data-id="element-242">
          MegaPack Detailer Argentino
        </h2>

        <p className="text-xl md:text-2xl font-medium max-w-2xl mx-auto mb-12 leading-relaxed text-[#FFFFFF] bg-[#6242EE]" data-id="element-243">
          Un sistema completo de detailing profesional, organizado por etapas y
          servicios, diseñado para que dejes de improvisar y empieces a cobrar
          lo que realmente vale tu trabajo.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto mb-12" data-id="element-244">
          <div className="p-8 rounded-2xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow bg-[#9F89FF]" data-id="element-245">
            <div className="text-5xl mb-4" data-id="element-246">🔧</div>
            <h3 className="text-xl font-bold text-gray-900" data-id="element-247">
              Abrís el MegaPack
            </h3>
          </div>
          <div className="p-8 rounded-2xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow bg-[#9F89FF]" data-id="element-248">
            <div className="text-5xl mb-4" data-id="element-249">👆</div>
            <h3 className="text-xl font-bold text-gray-900" data-id="element-250">
              Elegís el servicio
            </h3>
          </div>
          <div className="p-8 rounded-2xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow bg-[#9F89FF]" data-id="element-251">
            <div className="text-5xl mb-4" data-id="element-252">💰</div>
            <h3 className="text-xl font-bold text-gray-900" data-id="element-253">
              Lo ejecutás y cobrás
            </h3>
          </div>
        </div>

        <p className="text-2xl md:text-3xl font-black uppercase tracking-wide text-[#FFFFFF]" data-id="element-254">
          Sin vueltas. Sin improvisar. Sin perder plata.
        </p>
      </div>
    </section>;
}